import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { receiveUser, requestUser } from "actions/user";
import { getUser } from "interfaces/user";
import type { IUser } from "types/user";

export function useUser(
  options?: Omit<UseQueryOptions<IUser, unknown, IUser, ["user"]>, "queryFn">
) {
  const dispatch = useDispatch();
  return useQuery(["user"], {
    ...options,
    queryFn: async () => {
      dispatch(requestUser());
      const user = await getUser();
      dispatch(receiveUser(user));
      return user;
    },
  });
}
